import CmsComponentButton from "@/helpers/editor/components/CmsComponentButton.js";
import CmsComponentGlyph from "@/helpers/editor/components/CmsComponentGlyph.js";
import CmsComponentImage from "@/helpers/editor/components/CmsComponentImage.js";
import CmsComponentText from "@/helpers/editor/components/CmsComponentText.js";
import CmsBlock from "@/helpers/editor/blocks/CmsBlock.js";
import {tr} from "@vue-components/helpers/I18nPluginHelper.js";
import CmsBlockColumn from "@/helpers/editor/blocks/CmsBlockColumn.js";
import {extractHtmlText} from "@vue-components/helpers/utils.js";

export default class CmsBlockTextAndImage extends CmsBlock {
    static typeDef = {
        name: `Text and Image|Texte et image`,
        type: `text-and-image`,
        category: `preset`,
        glyph: `fa-block-quote`,
        isParent: false
    }

    get displayName() {
        if (this.item) {
            return tr(this.item.name);
        } else {
            return extractHtmlText(tr(this.title.text), 24);
        }
    }

    get parentClasses() {
        return [CmsBlockColumn];
    }

    get layoutPresets() {
        return [
            {
                id: `default`,
                name: `Default|Défaut`
            },
            {
                id: `reverse`,
                name: `Reverse|Inversé`
            },
            {
                id: `row-left`,
                name: `Row Left|Ligne à gauche`
            },
            {
                id: `row-right`,
                name: `Row Right|Ligne à droite`
            }
        ]
    }

    constructor(data, page) {
        // compatibility, init with inactive component
        if (data && !data.glyph)
            data.glyph = false;
        if (data && !data.altButton)
            data.altButton = false;

        super(data, page);

        this.image = new CmsComponentImage(this.image);

        this.glyph = new CmsComponentGlyph(this.glyph);

        this.title = new CmsComponentText(this.title);
        this.subtitle = new CmsComponentText(this.subtitle);
        this.description = new CmsComponentText(this.description);

        this.button = new CmsComponentButton(this.button);
        this.altButton = new CmsComponentButton(this.altButton);

        if (this.span == null) {
            this.span = 6;

            const devices = [`mobile`, `tablet`, `kiosk`];
            for (let d of devices) {
                if (!this.mediaQuery[d].hasOwnProperty(`span`)) {
                    this.mediaQuery[d].span = this.span;
                }
            }
        }

        if (!data) {
            this.layout = `row-left`;

            this.glyph.active = false;

            this.title.initText({}, `h2`);

            this.subtitle.active = false;
            this.subtitle.initText({}, `h4`);

            this.button.active = false;
            this.altButton.active = false;
        }
    }
}
